import {
  ChecklistSectionCreateOutDto,
  ChecklistSectionUpdateOutDto,
} from 'shared/dtos/out/template';
import {
  ChecklistSectionCreateModel,
  ChecklistSectionEditModel,
} from '../types/model';

export function checklistSectionCreateModelToOutDto(
  model: ChecklistSectionCreateModel
): ChecklistSectionCreateOutDto {
  const dto: ChecklistSectionCreateOutDto = {
    title: model.title,
    description: model.description,
  };

  if (model.parentSectionId) {
    dto.parentSectionId = model.parentSectionId;
  }

  return dto;
}

export function checklistSectionEditModelToOutDto(
  model: ChecklistSectionEditModel
): ChecklistSectionUpdateOutDto {
  return {
    title: model.title,
    description: model.description,
  };
}
